// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // DialogContentText,
  Tooltip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  Button,
  Table,
  TableRow,
  TableCell,
  Divider,
  // Divider,
  // FormControlLabel,
  // Switch,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import Editor from "react-simple-wysiwyg";
import { useAuthUser } from "react-auth-kit";

function ProductSamplingPromotionsPage() {
  const pageTitle = "Product Sampling Promotions";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [promotions, setPromotions] = useState([]);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [campaignType, setCampaignType] = useState("PSA");

  const [campaignPackages, setCampaignPackages] = useState([]);
  const [openPackagesDialog, setOpenPackagesDialog] = useState(false);

  const [campaignMeta, setCampaignMeta] = useState({});

  const tableColumns = [
    { Header: "#", accessor: "actions", align: "left" },
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Added On", accessor: "created", align: "right" },
  ];

  const buildTableRows = (data) => {
    const rows = [];
    data.map((campaign) => {
      let statusColor = "warning";
      if (campaign.status) {
        statusColor = "success";
      } else {
        statusColor = "error";
      }

      rows.push({
        title: campaign.title,
        status: (
          <MDBox>
            <Icon color={statusColor}>{campaign.status ? "check_circle" : "cancel"}</Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Insights">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                circular
                onClick={() => {
                  let url = `/trade-marketing/promotions/product-sampling/insights/${campaign.reference}`;
                  navigate(url);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  bar_chart
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;&nbsp;
            <Tooltip title="Manage">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                circular
                onClick={() => {
                  let url = `/trade-marketing/promotions/product-sampling/${campaign.reference}`;
                  navigate(url);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  settings
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: campaign.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/psa/promotions.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildTableRows(result.data.data.promotions);
            setPromotions(rows);
            setCampaignPackages(result.data.data.packages);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createCampaign() {
    if (campaignType === null) {
      setSeverity("error");
      setErrMsg("Campaign type is required.");
      setOpen(true);
      return;
    }

    if (title === null) {
      setSeverity("error");
      setErrMsg("Campaign title is required.");
      setOpen(true);
      return;
    }

    if (description === null) {
      setSeverity("error");
      setErrMsg("Campaign description is required.");
      setOpen(true);
      return;
    }

    if (!["SALES", "DATA"].includes(campaignType)) {
      if (Object.entries(campaignMeta).length === 0) {
        setSeverity("error");
        setErrMsg("Please fill out the form properly.");
        setOpen(true);
        return;
      }
    }

    // if (endDate === null) {
    //   setSeverity("error");
    //   setErrMsg("Campaign end required");
    //   setOpen(true);
    //   return;
    // }

    setOpenNewCheckDialog(false);
    setShowLoading(true);
    const json = {
      title: `${title}`,
      description: `${description}`,
      dispense_count: 0,
      payment_required: false,
      fee_bearer: "MERCHANT",
      is_shipping_required: false,
      voucher_price: 0,
      agent_commission: 0,
      unique_customer: "OPEN",
      end_date: null,
      campaign_type: campaignType,
      meta: campaignMeta,
    };

    await axios
      .post("portal/campaigns/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg("Campaign created!");
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openPackagesDialog} fullWidth maxWidth="lg">
        <DialogTitle>
          <MDBox align="center" mb={3}>
            Campaign Plans
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <Grid container spacing={3}>
              {campaignPackages.map((pckg) => (
                <Grid item xs={12} md={3} lg={3}>
                  <Card>
                    <MDBox p={0}>
                      <MDBox align="center" mt={1}>
                        <MDTypography variant="h6">{pckg.title}</MDTypography>
                        <MDTypography fontSize={14}>{`${accountInfo.account.currency}${(
                          pckg.price / 100
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}</MDTypography>
                        <MDTypography fontSize={12}>{pckg.duration} days</MDTypography>
                      </MDBox>
                      <MDBox mt={2}>
                        <Table>
                          <TableRow>
                            <TableCell>
                              <MDTypography>
                                <MDTypography fontSize={12}>Capped At</MDTypography>
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.sales_cap.toLocaleString("en", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Sales Overage</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.is_sales_fee_percentage
                                  ? `${(pckg.sales_fee * 100).toFixed(2)}%`
                                  : `${accountInfo.account.currency}${(
                                      pckg.sales_fee / 100
                                    ).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          {pckg.is_sales_fee_percentage && (
                            <>
                              {pckg.sales_fee_min && (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography fontSize={12}>Fee (min)</MDTypography>
                                  </TableCell>
                                  <TableCell>
                                    <MDTypography align="right" fontSize={12}>{`${
                                      accountInfo.account.currency
                                    }${(pckg.sales_fee_min / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}</MDTypography>
                                  </TableCell>
                                </TableRow>
                              )}

                              {pckg.sales_fee_max && (
                                <TableRow>
                                  <TableCell>
                                    <MDTypography fontSize={12}>Fee (max)</MDTypography>
                                  </TableCell>
                                  <TableCell>
                                    <MDTypography align="right" fontSize={12}>{`${
                                      accountInfo.account.currency
                                    }${(pckg.sales_fee_max / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}</MDTypography>
                                  </TableCell>
                                </TableRow>
                              )}
                            </>
                          )}
                        </Table>
                      </MDBox>
                      <MDBox mt={3}>
                        <Table>
                          {/* <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Data Capture Cap</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {pckg.data_cap.toLocaleString("en", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                            </TableCell>
                          </TableRow> */}
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Data Overage</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>{`${
                                accountInfo.account.currency
                              }${(pckg.data_fee / 100).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}</MDTypography>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              ))}
            </Grid>
            <MDBox mt={3}>
              <Alert severity="info">
                <MDTypography variant="h6" fontSize={12}>
                  Overages apply only when plan cap is exceeded.
                </MDTypography>
              </Alert>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPackagesDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewCheckDialog}>
        <DialogTitle>
          <MDBox>New Activation</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                placeholder="E.g Chicken Republic Deal"
                name="title"
                margin="dense"
                label="Activation Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <Editor
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter a meaningful description..."
              />
            </MDBox>
            <MDBox mt={4}>
              <Divider />
              <MDBox mt={3}>
                <MDBox mb={2}>
                  <Alert severity="info">
                    <MDTypography fontSize={12}>
                      <b>Instant (Dry):</b> For products that can be sampled on the spot. Feedback is
                      collected instantly.
                      <br />
                      <b>After Use (Wet):</b> For products that need to be used first. Feedback is
                      collected after usage.
                    </MDTypography>
                  </Alert>
                </MDBox>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Feedback Type</InputLabel>
                  <Select
                    label="Feedback Type"
                    onChange={(e) => {
                      setCampaignMeta((prev) => ({
                        ...prev,
                        is_instant_feedback: e.target.value,
                      }));
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    <MenuItem value={true}>Instant (Dry)</MenuItem>
                    <MenuItem value={false}>After Use (Wet)</MenuItem>
                  </Select>
                </FormControl>
                {campaignMeta && campaignMeta.is_instant_feedback === false && (
                  <MDBox mt={2}>
                    <MDInput
                      margin="dense"
                      label="Feedback Wait Time (days)"
                      type="number"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => {
                        let tmpMeta = campaignMeta;
                        tmpMeta["feedback_window"] = e.target.value;
                        setCampaignMeta(tmpMeta);
                      }}
                    />
                    <Alert severity="info">
                      <MDTypography fontSize={12}>
                        Number of days to wait before system prompts customer for feedback.
                      </MDTypography>
                    </Alert>
                  </MDBox>
                )}
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewCheckDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createCampaign();
            }}
          >
            Create Activation
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={1} pb={3}>
        {pageLoaded && (
          <MDBox align="right">
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={1}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>thumb_up</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                        Product Sampling Activations
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={16}>
                        Setup and manage your product sampling activations seamlessly.
                        <br />
                        Monitor and track products sampled, customer feedback, agent and location
                        performance.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3} mb={3} display="flex" alignItems="center" justifyContent="center">
                      {/* {accountInfo.account.plan.code === "PAG" && (
                        <MDButton
                          color="warning"
                          onClick={() => setOpenPackagesDialog(true)}
                          variant="outlined"
                          startIcon={<>{accountInfo.account.currency}</>}
                        >
                          View Pricing
                        </MDButton>
                      )} */}
                      <MDButton
                        sx={{ ml: { xs: 1 } }}
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setOpenNewCheckDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Create Activation
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={0}>
                  <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium">
                      Activations
                    </MDTypography>
                  </MDBox>
                  <MDBox mt={0} mb={3}>
                    <DataTable
                      table={{ columns: tableColumns, rows: promotions }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ProductSamplingPromotionsPage;
